var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    _vm._b({ class: _vm.computedClass }, "article", _vm.$attrs, false),
    [
      _vm.title
        ? _c(
            "div",
            { staticClass: "jade-box__header" },
            [
              _vm.icon
                ? _c("jade-icon", { attrs: { use: _vm.icon, size: "medium" } })
                : _vm._e(),
              _c("jade-text", { attrs: { variant: "heading-xsmall" } }, [
                _vm._v(_vm._s(_vm.title)),
              ]),
              this.$slots.action
                ? _c(
                    "div",
                    { staticClass: "jade-box__action" },
                    [_vm._t("action")],
                    2
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      this.$slots.default
        ? _c("div", { staticClass: "jade-box__main" }, [_vm._t("default")], 2)
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }